import { getTexts } from '@twnel/web-components';
import { SUCCESS_TYPE, ERROR_TYPE } from 'utils/toastDispacher';
import { toastDispacher } from 'utils';
import {
  UPDATE_GLOBAL_FUNCTIONS,
  LOADING_GLOBAL_FUNCTIONS,
} from '../namespace';
import { getGlobalFunctions as getGlobalFunctionsSelector } from '../selectors';

const GLOBAL_FUNCTIONS_GETTER = 'GLOBAL_FUNCTIONS_GETTER';
const GLOBAL_FUNCTION_GETTER = 'GLOBAL_FUNCTION_GETTER';
const GLOBAL_FUNCTION_CREATION = 'GLOBAL_FUNCTION_CREATION';
const GLOBAL_FUNCTION_UPDATE = 'GLOBAL_FUNCTION_UPDATE';
const GLOBAL_FUNCTION_DELETION = 'GLOBAL_FUNCTION_DELETION';

const networkError = (error) => {
  if (!(error instanceof Error)) {
    return new Error(error);
  }
  return { ...error, name: 'TwnelNetwork' };
};

const throwNetworkError = (error) => {
  throw networkError(error);
};

/**
 * Obtener todas las funciones globales de la compañía
 */
export const fetchGlobalFunctions = (forceRefresh = false) => (dispatch, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());
  const state = getState();
  const cachedFunctions = getGlobalFunctionsSelector(state);

  if (!forceRefresh && Object.keys(cachedFunctions).length > 0) {
    return Promise.resolve(cachedFunctions);
  }

  dispatch({ type: LOADING_GLOBAL_FUNCTIONS, payload: { loading: true } });

  return api.functions.list()
    .then((functions) => {
      // Convertir el array de funciones a un objeto con el nombre como key
      const functionsObject = functions.reduce((acc, func) => {
        acc[func.name] = func;
        return acc;
      }, {});

      dispatch({
        type: UPDATE_GLOBAL_FUNCTIONS,
        payload: { functions: functionsObject },
      });

      return functionsObject;
    })
    .catch((error) => {
      dispatch({ type: LOADING_GLOBAL_FUNCTIONS, payload: { loading: false } });
      toastDispacher({ actionId: GLOBAL_FUNCTIONS_GETTER, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Obtener una función global específica por nombre
 */
export const fetchGlobalFunction = (functionName) => (dispatch, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.get(functionName)
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_GETTER, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Crear una nueva función global
 */
export const createGlobalFunction = (functionName, functionData) => (
  dispatch, getState, getContext,
) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.create(functionName, functionData)
    .then((newFunction) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_CREATION, texts, type: SUCCESS_TYPE });
      dispatch(fetchGlobalFunctions(true));
      return newFunction;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_CREATION, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Actualizar una función global existente
 */
export const updateGlobalFunction = (functionName, functionData) => (
  dispatch, getState, getContext,
) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.update(functionName, functionData)
    .then((updatedFunction) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_UPDATE, texts, type: SUCCESS_TYPE });
      dispatch(fetchGlobalFunctions(true));
      return updatedFunction;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_UPDATE, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Eliminar una función global
 */
export const deleteGlobalFunction = (functionName) => (dispatch, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.delete(functionName)
    .then(() => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_DELETION, texts, type: SUCCESS_TYPE });
      dispatch(fetchGlobalFunctions(true));
      return true;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_DELETION, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};
